import {
  IData,
  IAvailableProducts,
  IResponse,
} from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';

export default class ProfileService {
  public static fetchAvailableProducts(): Promise<IResponse<IData<IAvailableProducts[]>>> {
    return ApiService.getAndReturnData('subscription/available-products');
  }
}
